namespace $.$$ {

	export class $shm_dashboard_admin_user_add extends $.$shm_dashboard_admin_user_add {

		admin_authenticated() {
			return this.$.$shm_pb.admin_authenticated()
		}

		@ $mol_mem
		email( next?: string ) {
			if( next !== undefined ) this.message( '' )
			return next ?? ''
		}

		@ $mol_mem
		name( next?: string ) {
			if( next !== undefined ) this.message( '' )
			return next ?? ''
		}

		@ $mol_mem
		password( next?: string ) {
			if( next !== undefined ) this.message( '' )
			return next ?? ''
		}

		@ $mol_mem
		message( next?: string ) {
			return next ?? ''
		}

		submit_enabled() {
			return Boolean( this.admin_authenticated() && this.email().trim() && this.password() )
		}

		@ $mol_action
		submit( next?: Event ) {
			if( next === undefined ) return null

			if( !this.admin_authenticated() ) {
				this.message( 'Войдите как superuser' )
				return next
			}

			this.message( 'Создание...' )
			const email = this.email().trim()
			const password = this.password()

			const record = $mol_error_fence(
				()=> this.$.$shm_pb.create_record( 'users', {
					email,
					name: this.name().trim(),
					password,
					passwordConfirm: password,
					emailVisibility: true,
					verified: true,
				} ),
				error => {
					this.message( error.message )
					return null
				},
				promise => promise,
			)

			if( !record || $mol_promise_like( record ) ) return next

			this.email( '' )
			this.name( '' )
			this.password( '' )
			this.message( `Пользователь создан: ${ record.email || email }` )
			this.created( record.id )
			return next
		}

	}

}
